import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import "./About.css";
import drsyeda from "../Assets/dr-syeda-img.jpeg";
import drsyed from "../Assets/dr-syed-quadri.jpeg";

const About = () => {
  const [isOpenSyeda, setIsOpenSyeda] = useState(false);
  const [isOpenSyed, setIsOpenSyed] = useState(false);

  const toggleSyeda = () => setIsOpenSyeda(!isOpenSyeda);
  const toggleSyed = () => setIsOpenSyed(!isOpenSyed);

  return (
    <div className="about">
      <h1 className="provider">Meet Our Providers</h1>

      {/* Dr. Syeda Fatima Quadri */}
      <div className="about-container">
        <div
          className={`about-dropdown ${isOpenSyeda ? "active" : ""}`}
          onClick={toggleSyeda}
        >
          <div className="dropdown-header">
            <img src={drsyeda} alt="Dr. Syeda Fatima Quadri" className="dropdown-img" />
            <span className="dropdown-name">Dr. Syeda Fatima Quadri</span>
            <div className={`dropdown-arrow ${isOpenSyeda ? "rotate" : ""}`}>
              <ChevronDown size={22} />
            </div>
          </div>

          {isOpenSyeda && (
            <div className="dropdown-content">
              <div className="about-text">
                <div className="about-image">
                  <img src={drsyeda} alt="Dr. Syeda Quadri" />
                  <div className="image-caption">
                    <p>Dr. Syeda Fatima Quadri</p>
                    <p>MD (Psychiatry)</p>
                    <p>US Board Certified Psychiatrist</p>
                  </div>
                </div>

                <div className="text-content">
                  <h3>Dr. Syeda Fatima Quadri</h3>
                  <p>
                    Dr. Syeda Fatima Quadri is a board-certified psychiatrist with extensive
                    experience in treating adults across both inpatient and outpatient settings.
                    She provides compassionate, evidence-based care for conditions such as
                    depression, anxiety, bipolar disorder, PTSD, and OCD.
                  </p>
                  <p>
                    Dr. Quadri believes in a holistic and patient-centered approach that focuses
                    on understanding each individual's needs and guiding them toward long-term
                    emotional well-being. Her care combines empathy, clinical expertise, and
                    proven therapeutic methods.
                  </p>
                  <h3>Schedule a Consultation</h3>
                  <p>
                    Take the next step toward better mental health — schedule a virtual session
                    with Dr. Quadri today. At MindSpace LLC, your mental wellness is our priority.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Dr. Syed Quadri */}
      <div className="about-container">
        <div
          className={`about-dropdown ${isOpenSyed ? "active" : ""}`}
          onClick={toggleSyed}
        >
          <div className="dropdown-header">
            <img src={drsyed} alt="Dr. Syed Quadri" className="dropdown-img" />
            <span className="dropdown-name">Dr. Syed Quadri</span>
            <div className={`dropdown-arrow ${isOpenSyed ? "rotate" : ""}`}>
              <ChevronDown size={22} />
            </div>
          </div>

          {isOpenSyed && (
            <div className="dropdown-content">
              <div className="about-text">
                <div className="about-image">
                  <img src={drsyed} alt="Dr. Syed Quadri" />
                  <div className="image-caption">
                    <p>Dr. Syed Quadri</p>
                    <p>MD (Psychiatry)</p>
                    <p>US Board Certified Psychiatrist</p>
                  </div>
                </div>

                <div className="text-content">
                  <h3>Dr. Syed Quadri</h3>
                  <p>
                    Dr. Syed Quadri is a highly skilled psychiatrist specializing in adult mental
                    health care. He has broad clinical experience in both inpatient and outpatient
                    psychiatric treatment and focuses on conditions such as mood disorders, anxiety,
                    depression, and ADHD.
                  </p>
                  <p>
                    His treatment philosophy emphasizes personalized, evidence-based care with a
                    strong commitment to compassion and long-term wellness. Dr. Quadri helps
                    individuals build resilience and regain control over their mental health.
                  </p>
                  <h3>Schedule a Consultation</h3>
                  <p>
                    Begin your path to improved mental wellness with Dr. Quadri at MindSpace LLC.
                    Schedule your virtual consultation today and experience care designed around you.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default About;
